var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"type":"primary","icon":"el-icon-upload"}},[_vm._v("批量上报")])
}
var staticRenderFns = []

export { render, staticRenderFns }